import loadable, { LoadableComponent } from '@loadable/component';
import { QueryLoadingAbsolute } from 'modules/common/components/QueryLoading/QueryLoading';
import { RouteConfiguration } from 'modules/common/types/RouteConfiguration';
import { Route } from 'react-router-dom';
const PATH_HOME = '/bounty';
export const BountyRoutesConfig: { [key: string]: RouteConfiguration } = {
  Index: {
    path: PATH_HOME,
    generatePath: () => PATH_HOME,
  },
};

const LoadableBountyContainer: LoadableComponent<any> = loadable(
  async () =>
    import('./screens').then(module => module.Bounty),
  {
    fallback: <QueryLoadingAbsolute />,
  },
);


export function BountyRoutes() {
  return (
    <Route
      path={BountyRoutesConfig.Index.path}
      exact={true}
      component={LoadableBountyContainer}
    />
  );
}
